import { Country } from 'features/shared/enums/country';
import AddressFindEnumDTO from 'features/shared/enums/dynamic/AddressFindEnumDTO';
import { getFormattedZipCode, getStreetSection } from 'features/shared/helpers/AddressFormatter';
import React from 'react';
import Avatar from 'features/shared/components/avatar/Avatar';
import { TFunction } from "i18next";

interface Props {
  address: AddressFindEnumDTO;
  translate: TFunction;
}

const AddressOption = ({ address, translate }: Props) => {
  // sub-renders
  const renderCityPart = () => {
    if (address.cityPart && address.cityPart !== address.city) {
      return <span>, {address.cityPart}</span>;
    }    
  }

  // render
  return (
    <div className="d-flex align-items-center">
      <div className="mr-2 d-none d-sm-block">
        <Avatar icon="map-marked" size={35} iconSize={1.0625}  disableShadow />
      </div>
      <div style={{ minWidth: 0 }}> 
        <div>
          <span className="d-inline-block">{getStreetSection(address)},&nbsp;</span> 
          <span className="d-inline-block">
            {getFormattedZipCode(address.zipCode, address.countryCode as Country)} {address.city}
          </span>
        </div>
        <div className="small text-muted text-truncate">
          <span>{address.stateName}</span>
          <span>, {address.region}</span>
          <span>, {translate("addressOption.district")} {address.township}</span>
          {renderCityPart()}
        </div>
      </div>
    </div>
  );
}

export default AddressOption;
